<div class="datepicker">
  <label [for]="id"><span class="label" [innerHTML]="label"></span> @if (required) {
  <span class="required">*</span>
}</label>@if (tooltipText) {
<app-tooltip-card [label]="tooltipLabel" [text]="tooltipText"></app-tooltip-card>
}
<input [id]="id" [placeholder]="placeholder" #datepicker>
</div>
